import { doMutation } from "../../core-module/util/graphqlHelper";

export const updateEmployee = ({ id, input }) => {
  const mutation = require("../api/mutation/updateEmployee.gql");
  const variables = { id: id, input: input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.updateEmployee };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
